
import React from 'react';
import GetEvents from "../events/GetEvents";

const Events = () => {
  return <GetEvents />;
};

export default Events;